// extracted by mini-css-extract-plugin
export var dataCell = "_pd-2";
export var dataRow = "_pd-0";
export var headerRow = "_pd-1";